import React from 'react';
import { Spinner } from 'react-magma-dom';
import { CloudDownloadIcon } from 'react-magma-icons';
import { StyledButtonSpinnerWrapper } from '../../components/Styled/StyledWrappers';
import { COLORS } from '../../constants';

interface IDownloadIcon {
  icon?: JSX.Element;
  isLoading: boolean;
  size: number;
  spinner: {
    size?: number;
    color?: string;
    margin?: string;
    width?: string;
    height?: string;
  };
}

export const DownloadIcon = (props: IDownloadIcon): JSX.Element => {
  const { icon, isLoading, size, spinner } = props;
  const { size: spinnerSize, color, margin = '0', width, height } = spinner || {};

  return (
    <>
      {isLoading ? (
        <StyledButtonSpinnerWrapper className="file-download-loader" margin={margin} width={width} height={height}>
          <Spinner color={color} size={spinnerSize} />
        </StyledButtonSpinnerWrapper>
      ) : (
        (icon ?? <CloudDownloadIcon size={size} testId="download-icon" color={COLORS.seaBlue} />)
      )}
    </>
  );
};
